<template>
  <div class="min-vh-100 main-theme">
    <div class="p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">
        {{ id ? "EDIT" : "CREATE" }} API TRIGGER
      </h1>
    </div>
    <div class="mt-3 bg-white-border p-3" v-if="!isLoading">
      <b-row>
        <b-col>
          <InputText
            textFloat="Name"
            placeholder="Name"
            type="text"
            name="nameApi"
            v-model="form.schema.name"
            isRequired
            :isValidate="$v.form.schema.name.$error"
            :v="$v.form.schema.name"
          />
        </b-col>
        <b-col>
          <InputText
            textFloat="Description"
            placeholder="Description"
            type="text"
            name="descriptionApi"
            v-model="form.schema.description"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <toggle-button
            class="mt-1 mr-1"
            v-model="form.schema.active"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
          />
          <span class="ml-2 f-size-18 text-header">
            {{ form.schema.active ? "Active" : "Inactive" }}
          </span>
        </b-col>
      </b-row>
      <div class="mt-2 border">
        <div class="p-3 bgc-second">
          <span class="unit-font text-break">API Setting</span>
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="2">
              <InputSelect
                title="Request Type"
                name="requestTypeId"
                isRequired
                v-model="form.schema.requestTypeId"
                :options="requestTypeList"
                valueField="id"
                textField="name"
                @onDataChange="handleChangeType"
                :isValidate="$v.form.schema.requestTypeId.$error"
                :v="$v.form.schema.requestTypeId"
              />
            </b-col>
            <b-col md="10">
              <InputText
                textFloat="Request URL"
                placeholder="Request URL"
                type="text"
                name="requestUrlApi"
                isRequired
                v-model="form.schema.requestUrl"
                :isValidate="$v.form.schema.requestUrl.$error"
                :v="$v.form.schema.requestUrl"
              />
            </b-col>
          </b-row>
          <div class="position-relative">
            <b-link
              class="text-link btn-add"
              v-if="tabIndex !== 1"
              @click="handleAdd()"
              >Add</b-link
            >
            <b-tabs
              nav-wrapper-class="border-top border-right"
              content-class="border m-0 p-3"
              v-model="tabIndex"
            >
              <b-tab title="Header">
                <div>
                  <b-row v-for="(header, index) in form.header" :key="index">
                    <b-col>
                      <InputText
                        textFloat="Key"
                        placeholder="Key"
                        type="text"
                        name="header.key"
                        v-model="header.key"
                        :isValidate="
                          $v.form.header.$each.$iter[index].key.$error
                        "
                        :v="$v.form.header.$each.$iter[index].key"
                      />
                    </b-col>
                    <b-col class="pr-0">
                      <InputText
                        textFloat="Value"
                        placeholder="Value"
                        type="text"
                        name="header.value"
                        v-model="header.value"
                      />
                    </b-col>
                    <b-col cols="1" class="text-center mt-3 pt-3">
                      <font-awesome-icon
                        @click="handleDelete(header.id, index)"
                        icon="trash-alt"
                        class="pointer"
                      />
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="Body">
                <!-- :disabled="form.schema.requestTypeId === 1" -->
                <div>
                  <InputTextArea
                    class="mb-0"
                    type="text"
                    textFloat=""
                    name="schema.body"
                    rows="10"
                    v-model="form.schema.body"
                  />
                </div>
              </b-tab>
              <b-tab title="Parameter">
                <div>
                  <b-row
                    v-for="(parameter, index) in form.parameter"
                    :key="index"
                  >
                    <b-col>
                      <InputText
                        textFloat="Key"
                        placeholder="Key"
                        type="text"
                        name="parameter.key"
                        v-model="parameter.key"
                        :isValidate="
                          $v.form.parameter.$each.$iter[index].key.$error
                        "
                        :v="$v.form.parameter.$each.$iter[index].key"
                      />
                    </b-col>
                    <b-col class="pr-0">
                      <InputText
                        textFloat="Value"
                        placeholder="Value"
                        type="text"
                        name="parameter.value"
                        v-model="parameter.value"
                      />
                    </b-col>
                    <b-col cols="1" class="text-center mt-3 pt-3">
                      <font-awesome-icon
                        @click="handleDelete(parameter.id, index)"
                        icon="trash-alt"
                        class="pointer"
                      />
                    </b-col>
                  </b-row>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/api-trigger">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5">CANCEL</b-button>
          </router-link>
        </b-col>
        <b-col class="text-sm-right">
          <button
            type="button"
            @click="onSubmit()"
            :disabled="isDisabled"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import InputText from "@/components/inputs/InputText";
import InputTextArea from "@/components/inputs/InputTextArea";
import InputSelect from "@/components/inputs/InputSelect";
import { required, url, minValue, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "SettingTime",
  components: {
    ModalAlert,
    ModalAlertError,
    InputText,
    InputTextArea,
    InputSelect,
  },
  validations() {
    return {
      form: {
        schema: {
          name: { required },
          requestTypeId: { required, minValue: minValue(1) },
          requestUrl: { required, url },
        },
        header: {
          $each: {
            key: {
              required: requiredIf(function(item) {
                return item.value || (!item.key && !item.value);
              }),
            },
          },
        },
        parameter: {
          $each: {
            key: {
              required: requiredIf(function(item) {
                return item.value || (!item.key && !item.value);
              }),
            },
          },
        },
      },
    };
  },
  data: function() {
    return {
      isLoading: false,
      isDisabled: false,
      modalMessage: "",
      tabIndex: 0,
      id: this.$route.params.id,
      requestTypeList: [{ id: 0, name: "Please Select" }],
      form: {
        schema: {
          id: 0,
          brandId: this.$route.query.brandID,
          name: "",
          description: "",
          requestTypeId: 0,
          requestUrl: "",
          body: "",
          active: false,
        },
        parameter: [],
        header: [],
      },
    };
  },
  created: async function() {
    this.isLoading = true;
    await this.getRequestType();
    if (this.id) await this.getDetail();
    this.isLoading = false;
  },
  methods: {
    getRequestType: async function() {
      await this.axios
        .get(`${this.$baseUrl}/apitrigger/list/requesttype`)
        .then((data) => {
          if (data.result == 1) {
            this.requestTypeList = this.requestTypeList.concat(data.detail);
          }
        });
    },
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/apitrigger/${this.id}`)
        .then((data) => {
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) {
        if (this.$v.form.header.$error) this.tabIndex = 0;
        else if (this.$v.form.parameter.$error) this.tabIndex = 2;

        return;
      }

      this.isDisabled = true;
      await this.axios
        .post(`${this.$baseUrl}/apitrigger/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.handleSuccess(data.message);
          } else {
            this.handleFail(data.message);
          }
        })
        .catch((err) => {
          this.handleFail(err.message);
        });
        this.isDisabled = false;
    },
    handleChangeType(value) {
      this.form.schema.requestTypeId = value;
    },
    handleAdd() {
      let key =
        this.tabIndex === 0
          ? "header"
          : this.tabIndex === 2
          ? "parameter"
          : null;
      this.form[key].push({
        id: 0,
        key: "",
        value: "",
      });
    },
    handleDelete(id, index) {
      let key =
        this.tabIndex === 0
          ? "header"
          : this.tabIndex === 2
          ? "parameter"
          : null;
      let list = this.form[key];
      list.splice(index, 1);
    },
    async handleSuccess(msg = false) {
      this.modalMessage = msg || "Success";
      this.$refs.modalAlert.show();
      this.$router.push({ path: `/api-trigger` }).catch(() => {});
    },
    async handleFail(msg = false) {
      this.modalMessage = msg || "Fail";
      this.$refs.modalAlertError.show();
    },
    async hadleModalAlertClose() {
      this.$refs.modalAlert.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.create-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #5b57a5;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
}

::v-deep .text-link {
  text-decoration: underline;
  color: #0062ff;
}

::v-deep .text-link.disabled {
  opacity: 0.6;
  cursor: default !important;
}

.btn-add {
  position: absolute;
  top: 10px;
  right: 15px;
}
.main-theme .tabs .tab-pane.active > div {
  min-height: 235px !important;
}
</style>
